import type { LanguageCode } from '../../types';
import { checkLanguageExists } from '../../utils/check-language-exists';

export const checkIfLangEqualToSiteLang = (
  lang: LanguageCode,
  siteLang?: string
) => {
  if (!siteLang) {
    return false;
  }

  if (!checkLanguageExists(siteLang)) {
    const [primaryLang] = siteLang.split('-');

    return lang === primaryLang;
  }

  return lang === siteLang;
};
